import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import ProductBottle from './ProductBottle';
import { TYPE_LABELS, TYPE_COLORS } from './data';

const AlternativesSheet = ({ open, type, alternatives, onClose }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          key="backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/40 z-[90]"
        />
        <motion.div
          key="sheet"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', stiffness: 280, damping: 32 }}
          className="fixed left-0 right-0 bottom-0 z-[91] bg-white rounded-t-3xl shadow-2xl max-h-[80vh] overflow-hidden flex flex-col"
        >
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
            <div>
              <div
                className="inline-block text-[10px] font-black uppercase tracking-[0.25em] px-2.5 py-1 rounded-full mb-1"
                style={{
                  background: `${TYPE_COLORS[type]}15`,
                  color: TYPE_COLORS[type],
                }}
              >
                {TYPE_LABELS[type]}
              </div>
              <h3
                className="text-lg text-[#0d1f15] tracking-tight"
                style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800 }}
              >
                Other options in store
              </h3>
            </div>
            <button
              data-testid="alternatives-close"
              onClick={onClose}
              aria-label="Close"
              className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600"
            >
              <X size={18} />
            </button>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-auto px-4 sm:px-6 py-4">
            {alternatives.length === 0 ? (
              <p className="text-center text-[#5a7062] py-8">
                No other options available in this category.
              </p>
            ) : (
              <ul className="divide-y divide-gray-100">
                {alternatives.map((p) => (
                  <li
                    key={p.upc}
                    data-testid={`alt-${p.upc}`}
                    className="flex items-center gap-4 py-4"
                  >
                    <div
                      className="flex-shrink-0 rounded-xl flex items-center justify-center"
                      style={{
                        background: `${TYPE_COLORS[type]}10`,
                        width: 64,
                        height: 64,
                      }}
                    >
                      <ProductBottle color={TYPE_COLORS[type]} size={44} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div
                        className="text-sm sm:text-base text-[#0d1f15] leading-snug tracking-tight"
                        style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}
                      >
                        {p.description}
                      </div>
                      {(p.brand || p.price) && (
                        <div className="text-xs text-[#5a7062] mt-0.5 flex items-center gap-2">
                          {p.brand && <span>{p.brand}</span>}
                          {p.brand && p.price ? <span>·</span> : null}
                          {p.price ? <span>${Number(p.price).toFixed(2)}</span> : null}
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export default AlternativesSheet;
